import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ManageArea, manageUrl } from './ManageView';

/**
 * The settings addresses from before Content → Manage (2026-10-24) still work:
 * links in emails, agent replies and bookmarks land on the matching area. Old
 * Site settings sections moved to Code & tracking and Distribution, so the
 * #section decides where /site/settings goes.
 */
const SITE_SECTIONS: Record<string, ManageArea> = {
  visibility: 'site',
  identity: 'site',
  domain: 'site',
  history: 'site',
  analytics: 'code',
  verification: 'code',
  'content-types': 'site',
  theme: 'design',
  surface: 'design',
  'reader-questions': 'design',
};

export function ManageRedirect({ area }: { area?: ManageArea }) {
  const { hash } = useLocation();
  const section = hash.replace(/^#/, '');
  // Licensed feeds live in Account → Connections (2026-10-24).
  if (!area && section === 'feeds') return <Navigate to="/settings/connections#feeds" replace />;
  const to = area || SITE_SECTIONS[section] || 'site';
  const keep = section || undefined;
  return <Navigate to={manageUrl(to, keep)} replace />;
}
